import {Label} from 'platform/components';
import {Heading, VStack} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {useTenant} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

interface SupplierArticlesAddNewCatalogInfoPriceProps extends RequiredTestIdProps {
  label: string;
  price: number;
  currency: string;
}

export function SupplierArticlesAddNewCatalogInfoPrice(
  props: SupplierArticlesAddNewCatalogInfoPriceProps
) {
  const formatCurrency = useFormatCurrency();
  const tenant = useTenant();

  return (
    <VStack data-testid={props['data-testid']}>
      <Label>{props.label}</Label>
      <Heading size={4}>
        {formatCurrency(props.price, props.currency ?? tenant.tenantCurrency, 2)}
      </Heading>
    </VStack>
  );
}
